<ng-container *ngrxLet="event$; let event">
  <div class="row" *ngIf="event">
    <div class="col-md-12">
      <app-event [event]="event" [minified]="false" [showViewButton]="false" [backgroundFullWidth]="true"></app-event>
    </div>
  </div>
</ng-container>
